export * from './types';

export const COOKIEYES_BANNER_LOAD = 'cookieyes_banner_load';
export const COOKIEYES_CONSENT_UPDATE = 'cookieyes_consent_update';

export { CookieManagementProvider, CookieManagementContext } from './CookieManagementProvider';
export {
  usePostHogEvents,
  setPosthogCapture,
  identifyUser,
  setInternalUserProperty,
  setTenantGroup,
  resetPosthog,
} from './usePostHogEvents';
export * from './analyticsIdentity';
